import React, { useEffect, useState } from 'react'
import { useDrop } from 'react-dnd'
import ItemTypes from './ItemTypes'

const style: React.CSSProperties = {
  height: '12rem',
  width: '12rem',
  marginRight: '1.5rem',
  marginBottom: '1.5rem',
  color: 'white',
  padding: '1rem',
  textAlign: 'center',
  fontSize: '1rem',
  lineHeight: 'normal',
  float: 'left',
}

const Dustbin: React.FC = () => {
  const [name, setName] = useState(null)
  const [{ canDrop, isOver,  }, drop] = useDrop({
    accept: ItemTypes.BOX,
    drop: (item,monitor) => ( setName(monitor.getItem().name)),
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  })

  const isActive = canDrop && isOver
  let backgroundColor = '#5f85ff'
  if (isActive) {
    backgroundColor = 'darkgreen'
  } else if (canDrop) {
    backgroundColor = 'darkkhaki'
  }
// console.log(name)
  return (
    <div id='4' ref={drop} style={{ ...style, backgroundColor }}>
      {isActive ? 'Бросаем' : 'Перенести объект сюда'}
      {name && <div>Вы бросили {name}</div>}
    </div>
  )
}

export default Dustbin
